import React from 'react';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

const ContactSection = () => {
  const { t } = useLanguage();

  const contactInfo = [
    {
      icon: MapPin,
      label: t('address'),
      value: 'Maakotkantie 60',
      subvalue: '01450 Vantaa, Finland',
      link: 'https://maps.google.com/?q=Maakotkantie+60+01450+Vantaa'
    },
    {
      icon: Phone,
      label: t('phone'),
      value: '050 477 1588',
      link: 'tel:+358504771588'
    },
    {
      icon: Mail,
      label: t('email'),
      value: 'info@milazzo.fi',
      link: 'mailto:info@milazzo.fi'
    }
  ];

  return (
    <section id="contact" className="py-24 bg-gradient-to-b from-black to-red-950/20">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            {t('contactTitle')}
          </h2>
          <div className="h-1 w-20 bg-red-500 mx-auto"></div>
        </div>

        {/* Contact Cards */}
        <div className="grid md:grid-cols-3 gap-8 mb-16">
          {contactInfo.map((item, index) => (
            <a
              key={index}
              href={item.link}
              target={item.icon === MapPin ? '_blank' : '_self'}
              rel="noopener noreferrer"
              className="group bg-gradient-to-br from-red-950/30 to-black border border-red-900/30 rounded-lg p-8 hover:border-red-500/50 transition-all duration-300 transform hover:scale-105 hover:shadow-xl hover:shadow-red-500/10"
            >
              <div className="flex flex-col items-center text-center space-y-4">
                <div className="w-16 h-16 rounded-full bg-red-600/20 flex items-center justify-center group-hover:bg-red-600/30 transition-colors duration-300">
                  <item.icon className="w-8 h-8 text-red-500" />
                </div>
                <div>
                  <h3 className="text-red-500 text-sm font-bold tracking-wider mb-2">
                    {item.label}
                  </h3>
                  <p className="text-white font-medium text-lg">{item.value}</p>
                  {item.subvalue && (
                    <p className="text-gray-400 text-sm mt-1">{item.subvalue}</p>
                  )}
                </div>
              </div>
            </a>
          ))}
        </div>

        {/* Map Section */}
        <div className="bg-gradient-to-br from-red-950/30 to-black border border-red-900/30 rounded-lg overflow-hidden">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1976.5!2d25.08!3d60.37!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNjDCsDIyJzEyLjAiTiAyNcKwMDQnNDguMCJF!5e0!3m2!1sen!2sfi!4v1234567890"
            width="100%"
            height="450"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Milazzo Pizza Location"
            className="grayscale hover:grayscale-0 transition-all duration-500"
          ></iframe>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;